import { Snowflake, Send, Bell, BellRing } from "lucide-react";
import Logo from "./Logo";
import { TG_URL } from "../config";

const LINKS = [
  { label: "Chart", href: "#chart", testid: "nav-chart-link" },
  { label: "Community", href: "#community", testid: "nav-community-link" },
];

export default function NavBar({ snowOn, onToggleSnow, chimeOn, onToggleChime }) {
  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header data-testid="nav-header" className="fixed inset-x-0 top-0 z-50 px-4 pt-8">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 rounded-2xl border border-white/10 bg-[#0F141C]/80 px-4 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.4)] backdrop-blur-xl">
        <a href="#top" onClick={(e) => scrollTo(e, "#top")} className="flex items-center gap-3" data-testid="nav-logo-link">
          <Logo size={36} />
          <span className="font-display text-base font-extrabold tracking-tight text-slate-50 sm:text-lg">
            MerrySolmas<span className="text-[#00F5D4]">.com</span>
          </span>
        </a>

        <nav className="hidden items-center gap-6 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => scrollTo(e, l.href)}
              className="font-mono-x text-xs uppercase tracking-[0.2em] text-slate-400 transition-colors duration-200 hover:text-[#00F5D4]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            data-testid="chime-toggle"
            onClick={onToggleChime}
            aria-pressed={chimeOn}
            title={chimeOn ? "Mute jingle" : "Jingle bells"}
            className={`rounded-xl border p-2.5 transition-all duration-200 ${
              chimeOn
                ? "border-[#FF2B4A]/50 bg-[#FF2B4A]/10 text-[#FF2B4A]"
                : "border-white/10 bg-white/[0.04] text-slate-500 hover:text-slate-300"
            }`}
          >
            {chimeOn ? <BellRing className="h-4 w-4" /> : <Bell className="h-4 w-4" />}
          </button>
          <button
            data-testid="snow-toggle"
            onClick={onToggleSnow}
            aria-pressed={snowOn}
            title={snowOn ? "Pause snow" : "Let it snow"}
            className={`rounded-xl border p-2.5 transition-all duration-200 ${
              snowOn
                ? "border-[#00F5D4]/40 bg-[#00F5D4]/10 text-[#00F5D4]"
                : "border-white/10 bg-white/[0.04] text-slate-500 hover:text-slate-300"
            }`}
          >
            <Snowflake className="h-4 w-4" />
          </button>
          <a
            data-testid="nav-telegram-button"
            href={TG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#00F5D4] to-[#00E676] px-4 py-2.5 font-display text-xs font-extrabold text-black shadow-[0_0_20px_rgba(0,245,212,0.4)] transition-all duration-200 hover:scale-[1.03] hover:shadow-[0_0_30px_rgba(0,245,212,0.7)] active:scale-[0.97] sm:text-sm"
          >
            <Send className="h-4 w-4" />
            <span className="hidden sm:inline">Join Telegram</span>
            <span className="sm:hidden">TG</span>
          </a>
        </div>
      </div>
    </header>
  );
}
